<header>
  <app-nav [isHomePage]="isHomePage"></app-nav>
</header>
<main>
  <router-outlet></router-outlet>
</main>
<footer>
  <app-footer></app-footer>
</footer>
<p-scrollTop></p-scrollTop>